import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SearchStateService } from '../../services/search-state/search-state.service';

@Component({
    selector: 'search-page',
    templateUrl: './search-page.component.html',
    host: {'class': 'page-container'},
    styleUrls: ['./search-page.component.css'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class SearchPageComponent implements OnInit {
    selectedTabIndex = 0;

    constructor(private searchStateService: SearchStateService) { }

    ngOnInit() {
        console.log(this.searchStateService.getAssetSearchState());
        if (this.searchStateService.getAssetSearchState()) {
            this.selectedTabIndex = 0;
        }
        else if (this.searchStateService.getSiteSearchState()) {
            this.selectedTabIndex = 1;
        }
        else if (this.searchStateService.getCustomerSearchState()) {
            this.selectedTabIndex = 2;
        }
    }
}